// extracted by mini-css-extract-plugin
export default {"cls1":"uyesbNsw6N7Txsq2ndfN","cls2":"SXWdymr2wkU309CrvnQS uyesbNsw6N7Txsq2ndfN","isTabletDown":"WLEaXLZyC9cLC97E1TtU"};